import { render, staticRenderFns } from "./rewardBuildPartnersEdit.vue?vue&type=template&id=a2b87b5a&scoped=true&"
import script from "./rewardBuildPartnersEdit.vue?vue&type=script&lang=js&"
export * from "./rewardBuildPartnersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b87b5a",
  null
  
)

export default component.exports